import React, { Component, Fragment } from 'react';

import { Line } from 'react-chartjs-2';

class LineChartAnalitics extends Component {
  renderData = () => {
    const { labels, data } = this.props;
    let shadow = data.map((el, index) => {
      if (index !== 0) {
        return el * 0.7;
      } else {
        return el;
      }
    });
    return {
      labels: labels,
      datasets: [
        {
          data: data,
          backgroundColor: 'rgba(100,255,255, 0.1)',
          borderColor: '#1bccfc',
          lineTension: 0.1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: '#1bccfc',
          pointHoverBorderWidth: 4,
          pointHoverRadius: 5,
        },
        {
          data: shadow,
          backgroundColor: 'transparent',
          borderColor: 'rgba(0 ,0 , 0, 0.05)',
          lineTension: 0.1,
          pointBorderColor: 'transparent',
          pointBackgroundColor: 'transparent',
          hoverRadius: 0,
          pointRadius: 0,
          pointHitRadius: 0,
        },
      ],
    };
  };

  renderOptions = () => {
    const { maxValue, interval } = this.props;
    return {
      responsive: true,
      layout: {
        padding: {
          top: 20,
          left: 20,
        },
      },
      legend: {
        display: false,
      },
      scales: {
        xAxes: [
          {
            ticks: {
              fontSize: 15,
            },
            gridLines: {
              color: '#e0e2e3',
              bordeWidth: 1,
              borderDash: [9, 10],
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              min: 0,
              max: maxValue,
              stepSize: interval,
              padding: 5,
              fontSize: 14,
            },
            gridLines: {
              color: '#e0e2e3',
              bordeWidth: 1,
              zeroLineColor: 'transparent',
            },
          },
        ],
      },
      tooltips: {
        callbacks: {
          title: function(tooltipItem) {
            let view;
            tooltipItem.map(el => (view = el.yLabel));
            return `${view} Views`;
          },
          label: function(tooltipItem) {
            return tooltipItem.xLabel;
          },
        },
        backgroundColor: '#FFF',
        titleFontSize: 16,
        titleFontColor: '#000',
        bodyFontColor: '#000',
        bodyFontSize: 14,
        displayColors: false,
        xPadding: 30,
        yPadding: 10,
        borderColor: 'rgba(0,0,0,0.1)',
        borderWidth: 1,
        xAlign: 'center',
        yAlign: 'bottom',
        caretPadding: 10,
      },
    };
  };

  datasetKeyProvider = () => Math.random();

  render() {
    return (
      <Fragment>
        <Line
          data={this.renderData()}
          options={this.renderOptions()}
          datasetKeyProvider={this.datasetKeyProvider}
        />
      </Fragment>
    );
  }
}

export default LineChartAnalitics;



// WEBPACK FOOTER //
// ./src/components/LineChartAnalitics/LineChartAnalitics.js